import React from "react";
import { FormattedMessage } from "react-intl";
import { IconDropdown } from "../icons/svg";
const monthText = ["dialog_january", "dialog_february", "dialog_march", "dialog_april", "dialog_may", "dialog_june", "dialog_july", "dialog_august", "dialog_september", "dialog_october", "dialog_november", "dialog_december"];

class DatePicker extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         day: 0,
         month: 0,
         year: 0,
         selectedDay: false,
         selectedMonth: false,
         selectedYear: false,
      }

      this.handleSelectDay = this.handleSelectDay.bind(this);
      this.handleSelectMonth = this.handleSelectMonth.bind(this);
      this.handleSelectYear = this.handleSelectYear.bind(this);
      this.handleSetDay = this.handleSetDay.bind(this);
      this.handleSetMonth = this.handleSetMonth.bind(this);
      this.handleSetYear = this.handleSetYear.bind(this);
      this.renderMonth = this.renderMonth.bind(this);
      this.renderYear = this.renderYear.bind(this);
      this.onChange = this.onChange.bind(this);
   }

   componentWillMount() {
      if (this.props.timestamp) {
         const d = new Date(this.props.timestamp);
         this.setState({
            day: d.getDate(),
            month: d.getMonth() + 1,
            year: d.getFullYear(),
         })
      }
   }

   onChange() {
      if (this.props.onChange) {
         const { day, month, year } = this.state;
         this.props.onChange(new Date(year, month - 1, day));
      }
   }

   handleSelectDay() {
      if (!this.props.readOnly) {
         this.setState(old => {
            return {
               ...old,
               selectedDay: !old.selectedDay,
               selectedMonth: false,
               selectedYear: false
            }
         });
      }
   }

   handleSelectMonth() {
      if (!this.props.readOnly) {
         this.setState(old => {
            return {
               ...old,
               selectedDay: false,
               selectedMonth: !old.selectedMonth,
               selectedYear: false
            }
         });
      }
   }

   handleSelectYear() {
      if (!this.props.readOnly) {
         this.setState(old => {
            return {
               ...old,
               selectedDay: false,
               selectedMonth: false,
               selectedYear: !old.selectedYear
            }
         });
      }
   }

   handleSetDay(value) {
      this.setState({
         day: value
      }, this.onChange)
   }

   handleSetMonth(value) {
      this.setState({
         month: value
      }, this.onChange)
   }

   handleSetYear(value) {
      this.setState({
         year: value
      }, this.onChange)
   }

   renderDay() {
      let element = [];
      const { month, year } = this.state;
      const d = new Date();
      if (month !== 0) {
         d.setMonth(month);
      }
      if (year !== 0) {
         d.setFullYear(year);
      }
      d.setDate(0);
      for (let index = 1; index <= d.getDate(); index++) {
         element.push(<div className={`item ${this.state.day === index && "active"}`} key={index} onClick={() => this.handleSetDay(index)}>{index}</div>);
      }
      return element;
   }

   renderMonth() {
      let element = [];
      for (let index = 1; index <= 12; index++) {
         element.push(<div className={`item ${this.state.month === index && "active"}`} key={index} onClick={() => this.handleSetMonth(index)}>
            <FormattedMessage
               id={monthText[index - 1]}
            />
         </div>);
      }
      return element;
   }

   renderYear() {
      const startYear = new Date(+0).getFullYear();
      const endYear = new Date().getFullYear();
      let element = [];
      for (let index = startYear; index <= endYear; index++) {
         element.push(<div className={`item ${this.state.year === index && "active"}`} key={index} onClick={() => this.handleSetYear(index)}>{index}</div>);
      }
      return element;
   }

   componentDidUpdate(prevProps) {
      if (this.props.readOnly && prevProps.readOnly !== this.props.readOnly) {
         this.setState(old => {
            return {
               ...old,
               selectedDay: false,
               selectedMonth: false,
               selectedYear: false
            }
         });
      }
   }

   render() {
      const { selectedDay, selectedMonth, selectedYear, day, month, year } = this.state;
      return (
         <div className="form-date">
            <div className="date" onClick={this.handleSelectDay}>
               <div className="text">{day === 0 ? 'DD' : day}</div> <IconDropdown />
               <div className="hover" style={{ display: selectedDay ? 'block' : 'none' }}>
                  <div className="list-item">
                     {this.renderDay()}
                  </div>
               </div>
            </div>
            <div className="date" onClick={this.handleSelectMonth}>
               <div className="text">{month === 0 ? 'MM' : <FormattedMessage
                  id={monthText[month - 1]}
               />}</div><IconDropdown />
               <div className="hover" style={{ display: selectedMonth ? 'block' : 'none' }}>
                  <div className="list-item">
                     {this.renderMonth()}
                  </div>
               </div>
            </div>
            <div className="date" onClick={this.handleSelectYear}>
               <div className="text">{year === 0 ? 'YYYY' : year}</div><IconDropdown />
               <div className="hover" style={{ display: selectedYear ? 'block' : 'none' }}>
                  <div className="list-item">
                     {this.renderYear()}
                  </div>
               </div>
            </div>
         </div>
      )
   }
}

export default DatePicker;